import { gql } from '@apollo/client';
const ADD_SIZE_STANDARD_SIZE_NAME = gql `
  mutation AddSizeStandardSizeName($sizeStandardId: ID!, $name: String!) {
    addModelSpecificationSizeName(sizeStandardId: $sizeStandardId, name: $name) {
      modelSpecificationSizeName {
        id
        name
      }
    }
  }
`;
export default ADD_SIZE_STANDARD_SIZE_NAME;
